// Menu Jesień 2026 · pełne, oficjalne (z PDF Czekoladziarni)
// Format ceny "12 / 21" oznacza wersję małą / dużą (mała ok. 200 ml, duża ok. 400 ml).

export const MENU_CATEGORIES = [
  {
    id: 'goraca-czekolada',
    label: 'Czekolada na gorąco',
    tagline: 'Aksamit w filiżance',
    description:
      'Nasza specjalność. Prawdziwa, gęsta czekolada w kilkunastu odsłonach — od klasycznej po sezonową lotus biscoff.',
    image:
      'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/de3opuve_bc6411df-f1da-4bc8-ac24-b361d75715be.jpeg',
    priceHint: 'ceny: mała / duża',
    items: [
      { name: 'Klasyczna', price: '12 / 21 zł' },
      { name: 'Z wiśniami', price: '13 / 25 zł' },
      { name: 'Z malinami', price: '13 / 25 zł' },
      { name: 'Z gruszką', price: '13 / 24 zł' },
      { name: 'Z bitą śmietaną', price: '13 / 25 zł' },
      { name: 'Z bitą śmietaną i piankami', price: '14 / 26 zł' },
      { name: 'Z serem pleśniowym', price: '13 / 25 zł' },
      { name: 'Z gałką lodów', price: '25 zł' },
      { name: 'Z gałką lodów i owocami', price: '26 zł' },
      { name: 'Biała czekolada klasyczna', price: '12 / 21 zł' },
      { name: 'Biała czekolada z bitą śmietaną i owocami', price: '26 zł' },
      { name: 'Pistacjowa z malinową posypką', price: '27 zł' },
      { name: 'Ze słonym karmelem', price: '25 zł' },
      { name: 'Kinder Bueno', price: '25 zł' },
      { name: 'Z likierem Bailey\u2019s', price: '28 zł' },
      { name: 'Z Advokatem', price: '28 zł' },
      { name: 'Rafaello', price: '25 zł' },
      { name: 'Lotus Biscoff', price: '32 zł' },
      { name: 'Szarlotka z bitą śmietaną', price: '26 zł' },
      { name: 'Cynamonowa śliwka', price: '26 zł' },
      { name: 'Z konfiturą grzaniec', price: '26 zł' },
      { name: 'Bananowa', price: '26 zł' },
    ],
  },
  {
    id: 'czekolada-z-kawa',
    label: 'Czekolada z kawą',
    tagline: 'Espresso spotyka kakao',
    description:
      'Nasze autorskie połączenia gorącej czekolady i kawy — dla tych, którzy nie chcą wybierać.',
    image:
      'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/euajk5aa_abbbdd0c-7e5b-423c-afd7-9958426a7b5b.jpeg',
    items: [
      { name: 'Chocoffee', description: 'espresso z czekoladą', price: '23 zł' },
      { name: 'Chocoffee z gałką lodów', price: '24 zł' },
      { name: 'Choco latte', description: 'latte z czekoladą zamiast kawy', price: '23 zł' },
      { name: 'Chocoffee latte', description: 'latte z czekoladą i kawą', price: '26 zł' },
    ],
  },
  {
    id: 'kawa',
    label: 'Kawa',
    tagline: 'Ciepła klasyka',
    description:
      'Świeżo palona kawa parzona na miejscu — od espresso po smakowe latte.',
    image:
      'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/bakw440n_ac55a788-42f7-4181-92f9-0e32a5882c64.webp',
    items: [
      { name: 'Americano', price: '15 / 17 zł' },
      { name: 'Americano white', price: '17 / 19 zł' },
      { name: 'Espresso / doppio / macchiato', price: '12 / 14 zł' },
      { name: 'Cappuccino / flat white', price: '17 / 19 zł' },
      { name: 'Cappuccino pistacjowe', price: '25 zł' },
      { name: 'Cappuccino z likierem Bailey\u2019s', price: '28 zł' },
      { name: 'Latte', price: '19 zł' },
      { name: 'Latte ze słonym karmelem', price: '24 zł' },
      { name: 'Latte różane', price: '24 zł' },
      { name: 'Latte lawendowe', price: '23 zł' },
      { name: 'Latte pistacjowe', price: '26 zł' },
      { name: 'Pumpkin spice latte', price: '24 zł' },
      { name: 'Latte orzechowe', price: '24 zł' },
      { name: 'Lotus Biscoff latte', price: '27 zł' },
    ],
  },
  {
    id: 'kawa-na-zimno',
    label: 'Kawa na zimno',
    tagline: 'Mroźna przerwa',
    description:
      'Kawy mrożone z autorskimi kremami, syropami i lodami — na upalne dni i nie tylko.',
    image:
      'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/mzti0xll_Bez%20nazwy%20-%2022%20lipca%202026%2022.17.11.webp',
    items: [
      { name: 'Kawa mrożona klasyczna', description: 'podawana z bitą śmietaną', price: '22 zł' },
      { name: 'Kawa mrożona orzechowa', description: 'krem orzechowy, kawa latte, syrop orzechowy, bita śmietana, sos orzechowy, posypka orzechowa', price: '24 zł' },
      { name: 'Kawa mrożona pistacjowa', description: 'kawa latte z kremem pistacjowym, bitą śmietaną, posypana kruszonymi prażonymi pistacjami', price: '26 zł' },
      { name: 'Kawa mrożona ze słonym karmelem', description: 'słony karmel, kawa latte, gałka lodów, bita śmietana, sos karmelowy', price: '24 zł' },
      { name: 'Kawa affogato', description: 'lody waniliowe lub pistacjowe zalane espresso', price: '23 zł' },
    ],
  },
  {
    id: 'matcha',
    label: 'Matcha',
    tagline: 'Zielona energia',
    description:
      'Prawdziwa japońska matcha na lodzie, w kilku owocowych odsłonach.',
    image:
      'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/3hg2vxtk_Bez%20nazwy%20-%2022%20lipca%202026%2022.09.53.png',
    items: [
      { name: 'Matcha iced latte', price: '23 zł' },
      { name: 'Matcha iced truskawkowa', price: '26 zł' },
      { name: 'Matcha iced mango-marakuja', price: '26 zł' },
      { name: 'Matcha iced z białą czekoladą', price: '27 zł' },
    ],
  },
  {
    id: 'napary-rozgrzewajace',
    label: 'Napary rozgrzewające',
    tagline: 'Jesienne purée i korzenne syropy',
    description:
      'Autorskie, aromatyczne napary podawane na gorąco — jesienny gest dla zmarzniętych gości.',
    image: '/images/napary.png',
    items: [
      { name: 'Napar malina', description: 'purée malina, syrop róża, cytryna, imbir, pomarańcza', price: '23 zł' },
      { name: 'Napar morela-pigwa', description: 'purée morela, syrop pigwa, sok z cytryny, goździki, cynamon', price: '23 zł' },
      { name: 'Napar rokitnik', description: 'purée rokitnik, syrop wiśnia, syrop kasztan, rozmaryn, żurawina', price: '23 zł' },
      { name: 'Napar mango', description: 'purée mango, syrop pigwa, goździki, cytryna', price: '23 zł' },
      { name: 'Lemoniada brzoskwiniowa na gorąco', description: 'purée brzoskwiniowe, sok z cytryny, syrop imbirowy, jabłko, cytryna', price: '23 zł' },
    ],
  },
  {
    id: 'zimne-napoje',
    label: 'Zimne napoje',
    tagline: 'Lemoniady i klasyki',
    description:
      'Domowe lemoniady komponowane na miejscu oraz klasyczne napoje bezalkoholowe.',
    image:
      'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/1zdymb1o_c2ed7adf-efa0-4f18-af8d-a0754310fa41.jpeg',
    items: [
      { name: 'Lemoniada cytrusowa', price: '20 zł' },
      { name: 'Lemoniada różana', price: '18 zł' },
      { name: 'Lemoniada truskawkowa', price: '18 zł' },
      { name: 'Lemoniada marakuja', price: '18 zł' },
      { name: 'Lemoniada imbirowa', price: '20 zł' },
      { name: 'Pepsi / Mirinda / 7up / Tonic Schweppes', price: '10 zł' },
      { name: 'Sok pomarańczowy / jabłkowy', price: '10 zł' },
      { name: 'Woda mineralna', price: '10 zł' },
      { name: 'Piwo, napoje alkoholowe', description: 'o wybór zapytaj obsługę', price: '—' },
    ],
  },
  {
    id: 'desery-lodowe',
    label: 'Desery lodowe',
    tagline: 'Chłodne słodkości',
    description:
      'Deserowe kompozycje z lodów, bitej śmietany i sezonowych dodatków — o szczegóły zapytaj obsługę.',
    image:
      'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/8r1i0d50_IMG_3439.jpg',
    items: [
      { name: 'Deser lodowy owocowy lub czekoladowy', description: 'dwie gałki lodów, bita śmietana oraz dodatki — o szczegóły zapytaj obsługę', price: '27 zł' },
      { name: 'Czekolada', description: 'dwie gałki lodów, owoce i bita śmietana', price: '27 zł' },
    ],
  },
  {
    id: 'koktajle',
    label: 'Koktajle',
    tagline: 'Wieczorowa nuta',
    description:
      'Autorskie koktajle na bazie Aperolu, Prosecco i Malibu — komponowane w kawiarni.',
    image:
      'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/dofiuj57_f1cd0624-ee68-4edf-9e1d-4185ac2026dc.jpeg',
    items: [
      { name: 'Aperol Spritz', description: 'Aperol, Prosecco, pomarańcza', price: '31 zł' },
      { name: 'Aperol Summer Day', description: 'Aperol, purée truskawka, sok z cytryny, purée mirabelka, tonik różany', price: '30 zł' },
      { name: 'Aperol Watermelon Love', description: 'Aperol, purée marakuja, lemoniada arbuzowa', price: '30 zł' },
      { name: 'Hugo Spritz', description: 'syrop z kwiatów czarnego bzu, Prosecco, cytryna, mięta', price: '28 zł' },
      { name: 'Fresh Berry Coco', description: 'Malibu, syrop poziomka, tonik różany', price: '30 zł' },
      { name: 'Pornstar Coco', description: 'Malibu, purée marakuja, syrop waniliowy, lemoniada cytrynowa', price: '30 zł' },
      { name: 'Grzaniec', price: '24 zł' },
      { name: 'Grzaniec bezalkoholowy', price: '22 zł' },
    ],
  },
  {
    id: 'herbaty',
    label: 'Herbaty',
    tagline: 'Imbryki liściaste',
    description:
      'Sypane herbaty parzone w imbryczkach.',
    image:
      'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/z2cktqcp_1b74c1f7-3492-42d5-925d-2a478a66bcda.webp',
    priceHint: 'imbryczek 450 ml · 16 zł   |   900 ml · 19 zł   |   Herbata zimowa 200 ml · 24 zł',
    items: [
      { name: 'Herbata zimowa (200 ml)', description: 'aromatyczna czarna herbata podawana z syropem cynamonowo-pomarańczowym lub imbirowo-miodowym i dodatkami.', price: '24 zł' },
      { name: 'Czarna', description: 'herbata indyjska z regionu Assam. Drobne listki, słodkawy aromat z kwiatową nutą.' },
      { name: 'Earl Grey Blue', description: 'czarna Ceylon z bławatkiem i olejkiem z bergamotki.' },
      { name: 'Zielona', description: 'z chińskiej prowincji Yunnan. Napar o złocistej barwie, delikatny klasyczny aromat.' },
      { name: 'Cytryna i imbir', description: 'zielona z imbirem, trawą cytrynową i skórką cytryny.' },
      { name: 'Zaczarowany Ogród', description: 'jabłko, papaja, czarny bez, truskawka, słonecznik, bławatek.' },
      { name: 'Wiśnie w Rumie', description: 'jagody, wiśnie, hibiskus, ananas, rodzynki.' },
      { name: 'Słodkie Tropiki', description: 'hibiskus, jabłko, ananas, płatki kokosowe, róża, banan — na bazie czarnej.' },
      { name: 'Miłosny Krzew', description: 'hibiskus, rodzynki, róża, czarny bez, maliny, bławatek.' },
      { name: 'Grzaniec', description: 'cynamon, goździki, czarny bez, tarnina, czarna jagoda, aronia, głóg, jarzębina.' },
    ],
  },
  {
    id: 'zestaw-testowy',
    label: 'Zestaw testowy',
    tagline: 'Skomponuj własną degustację',
    description:
      'Autorski zestaw pięciu gorących czekolad do wyboru — idealny na pierwszą wizytę albo prezent-doświadczenie.',
    image:
      'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/8inttx4a_60142765-cbb8-4e1d-a005-53bc4fb525bd.jpeg',
    items: [
      {
        name: 'Zestaw testowy gorących czekolad',
        description: 'Wybierasz 5 z: z serem pleśniowym, z wiśniami, z malinami, z Advokatem, chocoffee, ze słonym karmelem, z bitą śmietaną, biała, pistacjowa, Kinder Bueno, klasyczna, rafaello.',
        price: '69 zł',
      },
    ],
    note: 'Oznacz nas w relacji na Instagramie, TikToku lub Facebooku i odbierz 10% zniżki na kolejną wizytę.',
  },
];

export const GALLERY = [
  'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/ssiby2cn_f3425678-c3b1-4ecd-a38c-ca9f8d7ea60b.JPG',
  'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/w9g408pt_ab137f4a-1b70-4f01-a02c-9a391b3bba88.JPG',
  'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/y63jmqzl_782070b0-290d-4fd6-94b4-f5b0b8192e4b.JPG',
  'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/kj1jctsv_628d4591-897a-4fa0-b263-6f10531957c5.webp',
  'https://customer-assets.emergentagent.com/job_wroclaw-pralines/artifacts/mgrf48qu_44ddff61-2c49-4200-a81b-564ca0430292.jfif',
  'https://customer-assets.emergentagent.com/job_wroclaw-pralines/artifacts/jbl124pi_02beac4a-2b81-4d88-856b-20795281d075.jfif',
  'https://customer-assets.emergentagent.com/job_wroclaw-pralines/artifacts/1gqn9fcb_756784f4-4f67-45df-b754-73509f727a30.jfif',
  'https://customer-assets.emergentagent.com/job_wroclaw-pralines/artifacts/a2dsj8wf_521ebab0-98af-41cf-a10f-507301cba9fe.jfif',
];

export const HERO_IMAGE =
  'https://customer-assets.emergentagent.com/job_wroclaw-pralines/artifacts/fs57vluh_3cab7501-0287-45cc-bc1a-42e2e25e3b64.jfif';

export const HERO_ACCENT_IMAGE =
  'https://customer-assets.emergentagent.com/job_wroclaw-pralines/artifacts/50r4pm1k_439fa889-c1aa-4baf-ba26-d4f3a909689d.jfif';

export const ABOUT_IMAGE =
  'https://customer-assets.emergentagent.com/job_wroclaw-pralines/artifacts/50r4pm1k_439fa889-c1aa-4baf-ba26-d4f3a909689d.jfif';

export const ORDER_OCCASIONS = [
  'Tort okolicznościowy',
  'Bombonierka personalizowana',
  'Prezent firmowy',
  'Ślub i wesele',
  'Chrzest / komunia',
  'Walentynki',
  'Boże Narodzenie',
  'Wielkanoc',
  'Inna okazja',
];

export const CAKES_CATEGORIES = [
  {
    id: 'serniki',
    label: 'Serniki',
    tagline: 'Pieczone w formie 26 cm',
    description:
      'Klasyczne receptury i autorskie warianty — każdy sernik wypiekany w naszej pracowni na zamówienie.',
    image:
      'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/sat5z3pe_57f10893-5c22-41ea-a5fe-c74800c8932d.jpeg',
    priceHint: 'cena za tortownicę o śr. 26 cm',
    items: [
      { name: 'Cytrynowy z białą czekoladą', price: '240 zł' },
      { name: 'Nowojorski z polewą czekoladową', price: '240 zł' },
      { name: 'Dyniowy', price: '240 zł' },
      { name: 'Kajmakowy z gruszką karmelizowaną', price: '240 zł' },
      { name: 'Pomarańczowy', price: '240 zł' },
      { name: 'Cytrynowy z musem truskawkowym', price: '240 zł' },
      { name: 'Bounty', price: '240 zł' },
      { name: 'Snickers', price: '240 zł' },
      { name: 'Truskawkowy z mascarpone', price: '240 zł' },
      { name: 'Oreo', price: '240 zł' },
      { name: 'Bananowy z czekoladą', price: '240 zł' },
      { name: 'Pistacjowy', price: '270 zł' },
    ],
  },
  {
    id: 'klasyki',
    label: 'Nasze klasyki',
    tagline: 'Pieczone codziennie',
    description:
      'Wypieki, które nigdy nie wychodzą z mody. Bezy, szarlotki, brownie i miodownik — receptury dopracowywane latami.',
    image:
      'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/6hne4khc_f140cb39-83a8-4f7d-8cb4-775160512be9.jpeg',
    priceHint: 'cena za tortownicę o śr. 26 cm',
    items: [
      { name: 'Szarlotka z bezą', price: '220 zł' },
      { name: 'Wiśniowe z bezą', price: '220 zł' },
      { name: 'Szarlotka klasyczna', price: '220 zł' },
      { name: 'Brownie z wiśniami', price: '240 zł' },
      { name: 'Malinowa chmurka', price: '250 zł' },
      { name: 'Marchewkowe', price: '250 zł' },
      { name: 'Miodownik', price: '270 zł' },
      { name: 'Red Velvet', price: '270 zł' },
    ],
  },
  {
    id: 'tarty',
    label: 'Tarty',
    tagline: 'Kruche spody, świeże owoce',
    description:
      'Sezonowe kompozycje na kruchym spodzie — od klasycznej pistacjowej z malinami po tiramisu i banoffee.',
    image:
      'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/4xjuuymt_3c85fd71-a273-47bd-a7b7-7205cdf58be0.jpeg',
    priceHint: 'cena za tortownicę o śr. 26 cm',
    items: [
      { name: 'Pistacjowa z malinami', price: '240 zł' },
      { name: 'Oreo z borówkami i malinami', price: '240 zł' },
      { name: 'Śliwka w czekoladzie', price: '240 zł' },
      { name: 'Tiramisu', price: '240 zł' },
      { name: 'Snickers', price: '240 zł' },
      { name: 'Banoffee', price: '240 zł' },
    ],
  },
  {
    id: 'torty',
    label: 'Torty',
    tagline: 'Na wesela, chrzciny, urodziny',
    description:
      'Smak, rozmiar i dekorację ustalamy indywidualnie z każdym klientem. Poniżej przykładowe smaki — wycena po rozmowie.',
    image:
      'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/toykhi53_Bez%20nazwy%20-%2022%20lipca%202026%2022.32.32.png',
    priceHint: 'wycena indywidualna',
    items: [
      { name: 'Czekoladowy z wiśniami', price: 'na zamówienie' },
      { name: 'Śmietankowy z truskawkami', price: 'na zamówienie' },
      { name: 'Kokosowy z malinami i brzoskwiniami', price: 'na zamówienie' },
      { name: 'Pistacja z maliną', price: 'na zamówienie' },
      { name: 'Tropikalny', price: 'na zamówienie' },
      { name: 'Leśny mech z truskawką, szpinakiem i miętą', price: 'na zamówienie' },
    ],
    note:
      'Smaki tortów, wielkość i dekoracje ustalamy indywidualnie wg. życzenia klienta.',
  },
];

export const PRALINY_IMAGES = [
  'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/wktt50kb_pralina.png',
  'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/5pwwoufy_7.png',
  'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/jl1uy2ed_5.png',
  'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/ayite5i2_4.png',
  'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/jpodh7vo_pralina%201.png',
  'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/vm3mswc9_Jab%C5%82ko-Karmel.png',
  'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/q31gxmdj_10.png',
  'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/zpxnpe1d_1%20%281%29.png',
  'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/zbymb7zt_2.png',
  'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/5ys9dhyh_31.png',
  'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/5cikjhj1_30.png',
  'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/fnfjrx7e_34.png',
  'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/gm6hj7zk_33.png',
  'https://customer-assets-rejwkqb3.emergentagent.net/job_wroclaw-pralines/artifacts/wvo7skt1_32.png',
];

export const PRALINY_LIST = [];

export const TESTIMONIALS = [
  {
    quote:
      'Najgęstsza, najgłębsza gorąca czekolada w mieście. Wracam tu od lat — i za każdym razem znajduję coś nowego w karcie.',
    author: 'Klaudia M.',
    role: 'Google · 5★',
  },
  {
    quote:
      'Brownie z wiśniami, dla którego warto przejechać pół kraju. Mała, klimatyczna kawiarnia w samym sercu Starego Miasta.',
    author: 'Recenzja kukbuk.pl',
    role: 'Magazyn kulinarny',
  },
  {
    quote:
      'Praliny ręcznie robione, limitowane serie z matchą i pistacją — poziom mistrzowski. Idealne na prezent.',
    author: 'Tomasz K.',
    role: 'Stały klient',
  },
  {
    quote:
      'Bombonierki z naszym logo na konferencję firmową — goście byli zachwyceni. Obsługa profesjonalna, smak bezbłędny.',
    author: 'Anna W.',
    role: 'Zamówienie firmowe',
  },
];

export const GIFT_AMOUNTS = [100, 200, 300, 500];

export const SHOP_INFO = {
  name: 'Czekoladziarnia Wrocław',
  address: 'ul. Więzienna 31, 50-118 Wrocław',
  phone: '+48 608 485 763',
  phoneRaw: '+48608485763',
  email: 'czekoladziarniawroclaw@gmail.com', // TODO: zaktualizować jeśli oficjalny adres jest inny
  instagram: 'https://www.instagram.com/czekoladziarniawroclaw/',
  facebook: 'https://www.facebook.com/CzekoladziarniaWroclaw',
  tiktok: 'https://www.tiktok.com/@czekoladziarnia.w?lang=pl-PL',
  mapsEmbed:
    'https://www.google.com/maps?q=ul.+Wi%C4%99zienna+31,+50-118+Wroc%C5%82aw&output=embed',
  hours: [
    { day: 'Poniedziałek – Czwartek', time: '11:00 – 21:00' },
    { day: 'Piątek – Sobota', time: '10:00 – 22:00' },
    { day: 'Niedziela', time: '10:00 – 22:00' },
  ],
};
